<router-outlet>
  <app-spinner />
</router-outlet>

<ngx-spinner size="medium" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
